export function capitalizeFirstLetter(str: string | null | undefined) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
}

type DateInput = string | Date | null | undefined;

const dateTimeFormat = new Intl.DateTimeFormat("cs-CZ", {
    timeZone: "Europe/Prague",
});

export function formatDate(date: DateInput, emptyPlaceholder: string = "") {
    if (!date) return emptyPlaceholder;
    const d = typeof date === "string" ? new Date(date) : date;
    if (d.getFullYear() === 1) return emptyPlaceholder;
    return dateTimeFormat.format(d);
}

// Similar to formatDate but allows custom template, e.g. "D.M.YYYY"
// Supported tokens: D, DD, M, MM, YYYY
export function formatDateWithTemplate(date: DateInput, template: string, emptyPlaceholder: string = "") {
    if (!date) return emptyPlaceholder;
    const d = typeof date === "string" ? new Date(date) : date;
    if (d.getFullYear() === 1) return emptyPlaceholder;

    const day = d.getDate();
    const month = d.getMonth() + 1;
    const year = d.getFullYear();

    return template
        .replace("DD", day.toString().padStart(2, "0"))
        .replace("D", day.toString())
        .replace("MM", month.toString().padStart(2, "0"))
        .replace("M", month.toString())
        .replace("YYYY", year.toString());
}

// Function returns array of dates, starting from input date and adding quarters (4 items) or half-years (2 items).
// Returned dates are not sorted - start date is first, then start date + interval, etc. If input date is invalid, returns null.
export function generateIntervalDates(startDate: DateInput, interval: "quarter" | "halfYear"): Date[] | null {
    const dates: Date[] = [];
    if (!startDate) return null;
    const d = typeof startDate === "string" ? new Date(startDate) : startDate;

    for (let i = 0; i < (interval === "quarter" ? 4 : 2); i++) {
        const newDate = new Date(d);
        if (interval === "quarter") {
            newDate.setMonth(d.getMonth() + i * 3);
        } else {
            newDate.setMonth(d.getMonth() + i * 6);
        }
        dates.push(newDate);
    }

    return dates;
}